import React from "react";

import { Filter } from "icons";

import { Button, Checkbox, Dropdown } from "clearsense-ui/components";

const FilterDropDown = ({
  visibleStats,
  setVisibleStats,
  hiddenStats,
  setHiddenStats,
}) => {
  const showStat = key => {
    const stat = hiddenStats.find(item => item.key === key);
    setHiddenStats(prev => prev.filter(item => item.key !== key));
    setVisibleStats(prev => {
      const newStats = [...prev, stat];
      newStats.sort((a, b) => a.name.localeCompare(b.name));
      return newStats;
    });
  };

  const hideStat = key => {
    const stat = visibleStats.find(item => item.key === key);
    setVisibleStats(prev => prev.filter(item => item.key !== key));
    setHiddenStats(prev => {
      const newStats = [...prev, stat];
      newStats.sort((a, b) => a.name.localeCompare(b.name));
      return newStats;
    });
  };

  const showAllStats = () => {
    const allStats = [...visibleStats, ...hiddenStats];
    setVisibleStats(allStats);
    setHiddenStats([]);
  };

  const hideAllStats = () => {
    const allStats = [...visibleStats, ...hiddenStats];
    setVisibleStats([]);
    setHiddenStats(allStats);
  };

  return (
    <Dropdown
      closeOnSelect={false}
      buttonStyle="text"
      buttonProps={{ icon: Filter, iconSize: 24 }}
    >
      <div className="flex flex-col">
        <div className="flex justify-between flex-none px-4 py-3 border-b bg-gray-50 dark:bg-cs-ui-gray-800">
          <Button
            label="Select all"
            style="secondary"
            disabled={hiddenStats.length === 0}
            onClick={() => showAllStats()}
          />
          <Button
            label="Clear all"
            style="secondary"
            className="mr-2"
            disabled={visibleStats.length === 0}
            onClick={() => hideAllStats()}
          />
        </div>

        <div className="shadow-inner dark:bg-cs-ui-gray-800">
          <ul className="list-none">
            {visibleStats.map(stat => (
              <li className="px-4 py-3 text-base font-normal" key={stat.key}>
                <Checkbox
                  checked
                  label={stat.name}
                  onChange={() => hideStat(stat.key)}
                />
              </li>
            ))}
            {hiddenStats.map(stat => (
              <li className="px-4 py-3 text-base font-normal" key={stat.key}>
                <Checkbox
                  label={stat.name}
                  onChange={() => showStat(stat.key)}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Dropdown>
  );
};

export default FilterDropDown;
